import React from 'react';
import { Form } from 'formik';

import Button, { ButtonSize, ButtonType } from '@/components/commons/button';
import Envelope from '@/components/commons/icons/Envelope';
import SingleSelect from '@/components/forms/select/SingleSelect';

import styles from '@/components/settings/Settings.module.css';
import {
    BIRTHDAY_EMAIL_FREQUENCY_OPTIONS,
    BIRTHDAY_EMAIL_MAXIMUM_BIRTHDAYS,
    BIRTHDAY_EMAIL_REMINDER_TIME,
    BIRTHDAY_EMAIL_CONTACT_TYPES,
    BIRTHDAY_EMAIL_SORT,
} from './Constants';

interface Props {
    readonly status?: { errors: any }
    readonly sendBirthdayMailNow: () => void
    readonly isSubmitting: boolean
    readonly isSendingMail: boolean
}

function BirthdaysForm({
    status = null,
    sendBirthdayMailNow,
    isSubmitting,
    isSendingMail,
}: Props) {
    const getErrorsIfAny = (fieldName: string) => {
        if (status?.errors && status.errors[fieldName]) {
            return status.errors[fieldName].join(', ');
        }
        return undefined;
    };

    return (
        <Form id="birthdays-form">
            <div className="gap-0 md:grid-cols-1 shadow-sm">

                <div className="flex flex-col lg:flex-row justify-between">
                    <h3 className={styles.headline}>
                        Birthdays
                        <p className="pt-[20px]">
                            We&apos;ll send you an email about any upcoming birthdays
                            among your contacts.
                        </p>
                    </h3>

                    <div className="flex flex-col lg:flex-row gap-5">

                        <Button
                            externalStyles="mx-auto block text-cleanSlate border-gray-300 border-y border-x w-full lg:w-[200px] h-10 bg-cirrusWhite py-0 px-0 "
                            size={ButtonSize.large}
                            text="Send birthdays list now"
                            onClick={() => {
                                sendBirthdayMailNow();
                            }}
                            disabled={isSubmitting || isSendingMail}
                            icon={<Envelope className="ml-3 mr-2" />}
                        />

                        <Button
                            size={ButtonSize.small}
                            type={ButtonType.submit}
                            text="Save Settings"
                            disabled={isSubmitting}
                            externalStyles="mx-auto block border-gray-300 border-y border-x w-full lg:w-[114px] h-10 py-0 px-0"
                            form="birthdays-form"
                        />

                    </div>
                </div>
                <div className="flex mt-9 lg:mt-0">
                    <div className={styles.itemWidthFull}>
                        <div className="w-full sm:w-1/2 md:w-3/12">
                            <SingleSelect
                                classNamePrefix="birthdayEmailFrequency"
                                options={BIRTHDAY_EMAIL_FREQUENCY_OPTIONS}
                                name="birthdayEmailFrequency"
                                error={getErrorsIfAny('birthdayEmailFrequency')}
                                errorText={getErrorsIfAny('birthdayEmailFrequency')}
                                label="How often should we send the email?"
                            />
                        </div>

                        <br />

                        <div className="w-full sm:w-1/2 md:w-3/12">
                            <SingleSelect
                                classNamePrefix="birthdayEmailMaxBirthdays"
                                options={BIRTHDAY_EMAIL_MAXIMUM_BIRTHDAYS}
                                error={getErrorsIfAny('birthdayEmailMaxBirthdays')}
                                errorText={getErrorsIfAny('birthdayEmailMaxBirthdays')}
                                name="birthdayEmailMaxBirthdays"
                                label="What&apos;s the maximum number of birthdays we should include?"
                            />
                        </div>

                        <br />

                        <div className="w-full sm:w-1/2 md:w-3/12">
                            <SingleSelect
                                classNamePrefix="birthdayEmailReminderDays"
                                options={BIRTHDAY_EMAIL_REMINDER_TIME}
                                error={getErrorsIfAny('birthdayEmailReminderDays')}
                                errorText={getErrorsIfAny('birthdayEmailReminderDays')}
                                name="birthdayEmailReminderDays"
                                label="When would you like to receive a birthday reminder?"
                            />
                        </div>

                        <br />

                        <div className="w-full sm:w-1/2 md:w-3/12">
                            <SingleSelect
                                classNamePrefix="birthdayEmailContactType"
                                options={BIRTHDAY_EMAIL_CONTACT_TYPES}
                                error={getErrorsIfAny('birthdayEmailContactType')}
                                errorText={getErrorsIfAny('birthdayEmailContactType')}
                                name="birthdayEmailContactType"
                                label="What types of contacts should we include? "
                            />
                        </div>

                        <br />

                        <div className="w-full sm:w-1/2 md:w-3/12">
                            <SingleSelect
                                classNamePrefix="birthdayEmailSort"
                                options={BIRTHDAY_EMAIL_SORT}
                                error={getErrorsIfAny('birthdayEmailSort')}
                                errorText={getErrorsIfAny('birthdayEmailSort')}
                                name="birthdayEmailSort"
                                label="How would you like birthdays to be sorted?"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
}

export default BirthdaysForm;
